import classNames from 'classnames';
import { LinkFactoryReactRouter } from 'common/link/link-react-router.js';
import { REMOVE_MODULE_NAME } from 'components.modules.gen/placeholder-dataurl/dataUrlHook.js';
import { useAppSelector } from 'redux-state/configure-store.js';
import { IModuleConfig } from 'redux-state/layout/types.modules.js';
import { getDataUrlModuleData } from 'redux-state/modules-dataurl/utils.js';
import { HashHook } from 'utilities/hooks/hash-hook.js';
import { formatUrlSlug } from 'utilities/slugify.js';
import { formatStringModuleSidebar } from './secondary-list-utils.js';

export const SecondaryList = ({ navItems }: { navItems: IModuleConfig[] }) => {
  const [hashParam] = HashHook();
  const dataUrlObj = useAppSelector((state) => state.MODULE_DATA_URLS);

  return (
    <>
      {navItems.map((oldModuleConfig, index) => {
        const moduleConfig = getDataUrlModuleData({ oldModuleConfig, dataUrlObj });
        const { name } = moduleConfig;
        const finalUrlSlug = formatUrlSlug(moduleConfig);
        const key = `${name}${finalUrlSlug}${index}`;
        const isActive = hashParam === finalUrlSlug;
        const label = formatStringModuleSidebar(moduleConfig);
        if (name === REMOVE_MODULE_NAME) {
          return null;
        }

        return (
          <li className={classNames('Sidebar-item', { 'is-active': isActive })} key={key}>
            <LinkFactoryReactRouter className="fake-link u-linkClean" href={`#${finalUrlSlug}`}>
              {label}
            </LinkFactoryReactRouter>
          </li>
        );
      })}
    </>
  );
};
